<template>
  <div class="main">
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
    <b-row v-if="!loading">
      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <!-- <b-button variant="primary" to="/projectmanagementtimesheet/add" class="my-1">
            Add Timesheet
          </b-button> -->
        </div>
      </b-col>
      <b-col col="12" md="2" sm="2" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"  />
        </b-form-group>
      </b-col>
    

      <b-col cols="12"  class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
        <b-button variant="outline-danger"  @click="clearFilters">
          Clear Filters
        </b-button>
      </b-col>


      <b-col cols="12">
        <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredTimesheets"
          :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
          :filter-included-fields="filterOn" @filtered="onFiltered">

          <template #head(employeeID)="scope">
            <div class="d-flex flex-column">
              <span>User</span>
              <b-form-input
                v-model="filters.employeeName"
                placeholder="Search Employee Name"
                size="sm"
                @input="currentPage = 1"
              />
            </div>
          </template>
          <!-- Reference Filter -->
          <template #head(reference)="scope">
            <div class="d-flex flex-column">
              <span>Reference</span>
              <b-form-input v-model="filters.reference" placeholder="Search Reference" size="sm"
                @input="currentPage = 1" />
            </div>
          </template>

          <!-- Date Filter -->
          <template #head(date)="scope">
            <div class="d-flex flex-column">
              <span>Date</span>
              <DatePicker v-model="filters.dateRange" range format="YYYY-MM-DD" placeholder="Select date range"
                @change="currentPage = 1" style="width: 100%;" size="sm" />
            </div>
          </template>

          <!-- Status Filter -->
          <template #head(status)="scope">
            <div class="d-flex flex-column">
              <span>Status</span>
              <b-form-select v-model="filters.status" :options="[
                { value: null, text: 'All' },
                ...timesheetStatus
              ]" @change="currentPage = 1" size="sm" />
            </div>
          </template>

          <!-- Approval Date Filter -->
          <template #head(approvalDate)="scope">
            <div class="d-flex flex-column">
              <span>Approval Date</span>
              <DatePicker v-model="filters.approvalDateRange" range format="YYYY-MM-DD"
                placeholder="Select approval date range" @change="currentPage = 1" style="width: 100%;" size="sm" />
            </div>
          </template>

          <template #cell(employeeID)="data">
                {{ getEmployee(data.item.employeeID) }}
              </template>
              <template #cell(approvalDate)="data">
                {{ formatDate(data.item.approvalDate) }}
              </template>
          <template #cell(actions)="data">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
              <template v-slot:button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
              </template>

              <b-dropdown-item 
                    v-if="checkPermissions(data.item)" 
                    @click="timesheetAction('APPROVED', data.item)">
                    <feather-icon icon="CheckIcon" />
                    <span class="align-middle ml-50">Approve</span>
                  </b-dropdown-item>

                  <b-dropdown-item 
                    v-if="checkPermissions(data.item)" 
                    @click="timesheetAction('REJECTED', data.item)">
                    <feather-icon icon="XIcon" />
                    <span class="align-middle ml-50">Reject</span>
                  </b-dropdown-item>

              <b-dropdown-item :to="`/projectmanagementtimesheet/view/${data.item.id}`">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>View</span>
              </b-dropdown-item>
              <b-dropdown-item v-if="data.item.status === 'PENDING' && data.item.approverID === userId"
                :to="`/projectmanagementtimesheet/edit/${data.item.id}`">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Update</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="d-flex justify-content-center mb-1">
          <b-alert variant="warning" show v-if="timesheetList.length == 0" class="d-flex justify-content-center">
            <h4 class="alert-heading">No items found</h4>
          </b-alert>
        </div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner variant="success" label="Spinning" block v-if="loading"
            style="width: 3rem; height: 3rem"></b-spinner>
        </div>
      </b-col>

      <b-col cols="12">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
              class="mt-2" />
              <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
          </b-col>
    </b-row>

  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { formatDate, customError } from "@/libs/customFn";
import { TimesheetStatus } from '@/libs/defaultList';
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";
import moment from "moment";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    formatDate,
    DatePicker
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],

      timesheets:[],
      fields: [
      { key: "employeeID", label: "User", sortable: true, filter: true},
        { key: "reference", label: "Reference", sortable: true },
        {
          key: "date",
          label: "Date",
          sortable: true,
          formatter: (value, key, item) => formatDate(item.date),
        },
        // {
        //   key: "startDate",
        //   label: "Start Date",
        //   sortable: true,
        //   formatter: (value, key, item) => formatDate(item.startDate),
        // },
        // {
        //   key: "endDate",
        //   label: "End Date",
        //   sortable: true,
        //   formatter: (value, key, item) => formatDate(item.endDate),
        // },
        {
          key: "status",
          label: "Status",
          sortable: true,
          formatter: (value, key, item) => this.timesheetStatus.filter(x => x.value === item.status)[0].text
        },
        { key: "hoursWorked", label: "Total Hours", sortable: true, },
        {
          key: "approvalDate",
          label: "Approval Date",
          sortable: true,
          formatter: (value, key, item) => item.approvalDate ? formatDate(item.approvalDate) : "",

        },
        {
          key: "actions",
          label: "Actions",
          sortable: false
        },
      ],
      userId: null,
      timesheetStatus: TimesheetStatus,
      filters: {
        employeeName: '',
        reference: '',
        dateRange: [null, null],
        status: null,
        approvalDateRange: [null, null],
      },
      moduleReference: "Project",
    };
  },
  methods: {
    clearFilters() {
      this.filters = {
        reference: '',
        dateRange: [null, null],
        status: null,
        approvalDateRange: [null, null],
      };
      this.currentPage = 1;
    },
    ...mapActions("serviceModule", ["getServiceTimesheetListAction", "getServiceTimesheetAction", "putServiceTimesheetAction"]),
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    ...mapActions("userModule", ["getUserListAction"]),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getEmployee(id) {
      const employee = this.users.find((s) => s.id === id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },

   
  
    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("YYYY-MM-DD");
    },
        checkPermissions(item) {
    console.log("Item Status:", item.status);
    console.log("Module Type:", item.moduleType, "Expected:", this.moduleReference);
    console.log("User is Admin:", IsAdmin());
    console.log("User ID:", this.userId, "Approver ID:", item.approverID);

    return item.status === 'PENDING' 
      && (IsAdmin() || this.userId === item.approverID);
  },
    async timesheetAction(status, timesheet) {
      try {
        await this.getServiceTimesheetAction({modulereference: this.moduleReference, id: timesheet.id});

        // confirm update
        const result = await this.$swal({
          title: "Are you sure?",
          text: "You will not be able to revert your changes!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, update status!",
          cancelButtonText: "Cancel",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          const payload = {
            id: timesheet.id,
            approverID: timesheet.approverID,
            status: status,
            note: status,
            moduleReference: this.moduleReference
          };

          console.log("payload", payload);

          try {
            await this.putServiceTimesheetAction(payload)
            .then(() => {
              this.success();
              const modulereference = 'Project';
               //this.fetchTimesheetData();
          //      this.getServiceTimesheetListAction().then(() => {
          // this.timesheets = this.timesheetList;
          // this.totalRows = this.timesheets.length;
          //   });
          const userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;
         
      this.getServiceTimesheetListAction(modulereference).then(() => {
      if(IsAdmin()){
        
        this.timesheets = this.timesheetList;
        this.totalRows = this.timesheetList.length;
      }
      else {
       // console.log("employeeeeeeeeeeeeeManagerrrrrrrrrrrrrrrrrrrr");
        this.getServiceTimesheetListAction(modulereference).then(() => {
        this.timesheets = this.timesheetList.filter(x => x.employeeID == this.userId || x.approverID == this.userId);
        //console.log("this.timesheets", this.timesheets);
        this.totalRows = this.timesheets.length;
      });
      }
     });
          });
            
          } catch (updateError) {
            console.error("Error updating timesheet:", updateError);
            await this.$swal({
              title: "Error",
              text: "An error occurred while updating the timesheet.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching timesheet:", error);
        await this.$swal({
          title: "Error",
          text: "An error occurred while fetching the timesheet data.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    },

    success(message) {
      this.$swal({
        title: "Timesheet Status Updated!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
  },
  computed: {
    filteredTimesheets() {
  return this.timesheets.filter((timesheet) => {
    const employeeFullName = this.getEmployee(timesheet.employeeID).toLowerCase();

    const matchesEmployee = !this.filters.employeeName ||
      employeeFullName.includes(this.filters.employeeName.toLowerCase());

    const matchesReference = !this.filters.reference ||
      (timesheet.reference && timesheet.reference.toLowerCase().includes(this.filters.reference.toLowerCase()));

    const matchesDate =
      !this.filters.dateRange[0] || !this.filters.dateRange[1] ||
      (new Date(timesheet.date) >= new Date(this.filters.dateRange[0]) &&
        new Date(timesheet.date) <= new Date(this.filters.dateRange[1]));

    const matchesStatus = this.filters.status === null || timesheet.status === this.filters.status;

    const matchesApprovalDate =
      !this.filters.approvalDateRange[0] || !this.filters.approvalDateRange[1] ||
      (new Date(timesheet.approvalDate) >= new Date(this.filters.approvalDateRange[0]) &&
        new Date(timesheet.approvalDate) <= new Date(this.filters.approvalDateRange[1]));

    return matchesEmployee && matchesReference && matchesDate && matchesStatus && matchesApprovalDate;
  });
},
    ...mapGetters("serviceModule", {
      timesheetList: "timesheetList",
      loading: "loading",
    }),
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),
  },
  async mounted() {
    const modulereference = 'Project';

    await this.getUserListAction();

const userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;

    if(IsAdmin()){
     await this.getServiceTimesheetListAction(modulereference).then(() => {
    
      this.timesheets = this.timesheetList
      this.totalRows = this.timesheets.length;
    });

      }
      else {
        console.log("employeeeeeeeeeeeeeManagerrrrrrrrrrrrrrrrrrrr");
        console.log( this.userId);
        console.log("timesheetlist", this.timesheetList);
        this.getServiceTimesheetListAction(modulereference).then(() => {
        this.timesheets = this.timesheetList.filter(x => x.employeeID == this.userId || x.approverID == this.userId);
        //console.log("this.timesheets", this.timesheets);
        this.totalRows = this.timesheets.length;
      });
      }
     
//console.log("list", list);
    
    //this.totalRows = this.timesheetList.length;
  
  }
};
</script>
